// Sticky pagination total for list endpoints that report the record count on
// the FIRST page only (page 2+ responses carry it absent or 0). Trust and
// record the total only from a fulfilled page-1 response; on any other page
// keep serving the last recorded value. Feed it the query's `currentData`
// total (NOT `data`): `currentData` is undefined until the entry for the
// CURRENT args is fulfilled, so a stale response for previous args (a page-2
// zero lingering while a filter change refetches page 1) is never recorded.
// A genuine page-1 total of 0 IS recorded — empty states must read 0.

import { useEffect, useState } from 'react';

export default function useStickyTotal(currentTotal: number | undefined, page: number): number {
  const [total, setTotal] = useState(currentTotal ?? 0);

  useEffect(() => {
    if (page === 1 && currentTotal !== undefined) setTotal(currentTotal);
  }, [currentTotal, page]);

  // Serve a fresh page-1 total the render it arrives (the effect lands one
  // render later); everywhere else serve the remembered value.
  return page === 1 && currentTotal !== undefined ? currentTotal : total;
}
